import React, { Component } from 'react';
import BantCurrencyValue from './bantCurrencyValue';
import ChangeValue from './changeValue';
import Slider from "react-slick";

class Bant extends Component {

    settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows:false
    };

    state = {  
        values: [],
        ovalues: [],
    }

    componentDidUpdate(prevProps) {
  
      if ((this.props.avalues !== prevProps.avalues || this.props.dvalues !== prevProps.dvalues) && Array.isArray(this.props.avalues) && Array.isArray(this.props.dvalues)) 
      {
        var dsvalues = this.props.dvalues.filter( (value) => value.Kod === 'USD' || value.Kod === 'EUR');

        var asvalues = this.props.avalues.filter( (value) => value.Kod === 'CH' || value.Kod === 'B');

        var values = dsvalues.concat(asvalues)

        var ovalues = this.props.dvalues.filter( (value) => value.Kod === 'XAGUSD' || value.Kod === 'XAUUSD');

        this.setState({values})
        this.setState({ovalues})
      }
    }

    showCode = tag =>{
      if (tag['Kod'] === 'B')
        return <td>22 Ayar</td>
      else if (tag['Kod'] === 'CH')
        return <td>Külçe<span>(0.995)</span></td>
      else 
        return <td>{tag['Kod']}</td>
    }

    render() { 
      var settings = {
        dots: false,
        infinite: true,
        speed: 2000,
        slidesToShow: 4,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        arrows:false,
        responsive: [{
          breakpoint: 1700,
          settings: {
            slidesToShow: 3
          }
        }, {
          breakpoint: 1500,
          settings: {
            slidesToShow: 2
          }
        }, {
          breakpoint: 990,
          settings: {
            slidesToShow: 1
          }
        }]
      };

        return <div className="row bant">
                <div className="col-lg-12">
                <div className="row">
                <div className="col-lg-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="col-lg-12">
                        <Slider {...settings}>
                                  {this.state.values.map(tag => <div className="one-slide" key={tag['Kod']}><table className="bant"><tbody><tr>{this.showCode(tag)}<td>:</td><BantCurrencyValue id={'bbuy' + tag['Kod']} value={tag['Alis']}/><td>/</td><BantCurrencyValue id={'bsell' + tag['Kod']} value={tag['Satis']}/><ChangeValue value={tag['Change']} /></tr></tbody></table></div>)}
                                  {this.state.ovalues.map(tag => <div className="one-slide" key={tag['Kod']}><table className="bant"><tbody><tr><td>{tag['Kod']}</td><td>:</td><BantCurrencyValue id={'bbuy' + tag['Kod']} value={tag['Alis']}/><ChangeValue value={tag['Change']} /></tr></tbody></table></div>)}
                        </Slider>
                        </div>
                      </div>
                    </div>
                  </div>
                  </div>
                  </div>
                </div>;
    }

    
}

export default Bant;